import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Component } from '@angular/core';
import { LanguageService } from '@ibank-globals/language';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../../../globals/classes/base.component';
import { IPasswordValidationFields } from '../../../../../globals/classes/password-validator';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { ErrorMsgModalComponent } from '../../../error-msg-modal/error-msg-modal.component';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'create-code-new',
	template: require('./create-code-new.component.html'),
})
export class CreateCodeNewComponent extends BaseComponent implements OnInit {
	@Input() isOnboardingFlow: boolean;
	@Input() initRequest: IInitializePasswordRequest;
	@Output() onTermsToggled = new EventEmitter<boolean>();
	@Input() hasAcceptTerms: boolean = false;
	@Input() public isLoginBigModalEnabled: boolean = false;
	@Input() ibUsernameRequest: string;

	public strengthPercentage: number = 0;
	public validation: IPasswordValidationFields;
	public langId: string;
	public ibTermsEl: string = './Content/documents/ibTermsEl.pdf';
	public ibTermsEn: string = './Content/documents/ibTermsEn.pdf';
	public ibTermsNewEl: string = './Content/documents/ΟΡΟΙ_ΚΑΙ_ΠΡΟΥΠΟΘΕΣΕΙΣ_ΕΛ.pdf';
	public ibTermsNewEn: string = './Content/documents/ΟΡΟΙ_ΚΑΙ_ΠΡΟΥΠΟΘΕΣΕΙΣ_EN.pdf';
	public isPasswordVisible: boolean = false;
	public isConfirmPasswordVisible: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private _langSvc: LanguageService
	) {
		super();
	}

	ngOnInit() {
		this._initSubscriptions();
	}

	public ibankTermsPdf(): string {
		if (this.langId === 'el') {
			return this.ibTermsNewEl;
		} else return this.ibTermsNewEn;
	}

	public toggleSwitch(): void {
		this.hasAcceptTerms = !this.hasAcceptTerms;
		this.onTermsToggled.emit(this.hasAcceptTerms);
	}

	public toggleErrorMessage() {
		this.activeModal.close();
		this.modalService.open(ErrorMsgModalComponent, {
			windowClass: 'modal-small',
		});
	}

	private _initSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => (this.langId = lang));
	}
}
